import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { Button } from '../../components/button/button';
import { Grid, Text } from '@chakra-ui/react';
import { ButtonVariant } from '../../core/enums';
import { styles } from './organization.styles';
import { Select } from '../../components/select/select';
import { RowsPerPage } from '../../components/rows-per-page/rows-per-page';
const SubHeader = (props)=>{
    const classes = styles();
    const { title, linkButtonName, actionName, className, onLinkButtonClick, onActionClick, isActionDisabled, handleMenuItemClick, menuButtonName, menuItems, href, handleAnchorElementClick, anchorButtonName, anchorButtonVariant, primaryBtnName, isPrimaryBtnDisabled, onPrimaryBtnClick, pageSize, onPageSizeChange } = props;
    const anchorRef = useRef(null);
    const anchorButtonClick = ()=>{
        anchorRef.current.click();
    };
    const handleMenuItemSelection = (event)=>{
        const target = event.currentTarget;
        handleMenuItemClick && handleMenuItemClick(target.value);
    };
    return /*#__PURE__*/ _jsxs(Grid, {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                display: "flex",
                alignItems: "center",
                children: /*#__PURE__*/ _jsx(Text, {
                    sx: className,
                    children: title
                })
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                display: "flex",
                flexDirection: "row",
                columnGap: 3,
                children: [
                    pageSize && onPageSizeChange && /*#__PURE__*/ _jsx(RowsPerPage, {
                        pageSize: pageSize,
                        handlePageSize: onPageSizeChange,
                        className: classes.select
                    }),
                    linkButtonName && /*#__PURE__*/ _jsx(Button, {
                        label: linkButtonName,
                        variant: ButtonVariant.LINKS,
                        onClick: onLinkButtonClick,
                        name: linkButtonName,
                        dataTestId: `${linkButtonName}Btn`
                    }),
                    href && anchorButtonVariant && anchorButtonName && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                label: anchorButtonName ?? '',
                                name: anchorButtonName ?? '',
                                variant: anchorButtonVariant,
                                onClick: anchorButtonClick
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                hidden: true,
                                ref: anchorRef,
                                href: href,
                                "data-testid": anchorButtonName,
                                onClick: handleAnchorElementClick,
                                style: {
                                    display: 'block',
                                    textAlign: 'center',
                                    paddingTop: '10px',
                                    color: '#E5927D',
                                    textDecoration: 'none',
                                    outline: 'none'
                                },
                                children: anchorButtonName ?? ''
                            })
                        ]
                    }),
                    actionName && /*#__PURE__*/ _jsx(Button, {
                        label: actionName,
                        variant: ButtonVariant.PRIMARY,
                        onClick: onActionClick,
                        disabled: isActionDisabled,
                        name: actionName,
                        dataTestId: `${actionName}Btn`
                    }),
                    primaryBtnName && /*#__PURE__*/ _jsx(Button, {
                        label: primaryBtnName,
                        variant: ButtonVariant.PRIMARY,
                        onClick: onPrimaryBtnClick,
                        disabled: isPrimaryBtnDisabled,
                        name: primaryBtnName
                    }),
                    menuButtonName && menuItems.length > 0 && /*#__PURE__*/ _jsx(Select, {
                        items: menuItems,
                        value: menuButtonName,
                        onChange: handleMenuItemSelection,
                        classes: {
                            button: classes.button,
                            icon: classes.icon
                        },
                        dataTestId: `${menuButtonName}Btn`,
                        isMenuButton: true
                    })
                ]
            })
        ]
    });
};
SubHeader.displayName = 'SubHeader';
export { SubHeader };
